import { Injectable } from '@angular/core';
import { UIService } from '../shared/ui.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/index';
import { Order } from '../order/order.model';
import { environment } from '../../environments/environment';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  currentProject: number;

  constructor(
    private http: HttpClient,
    private uiService: UIService,
    private storageService: StorageService,
  ) { }


  getInvoices(token): Observable<any[]> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    this.currentProject = this.storageService.getPreferredProject();

    const body = {};

    if (this.currentProject !== null){
      body['project'] = this.currentProject.toString();
    }
    const url = environment.APIEndpoint + 'client-api/invoices/';
    return this.http.get<[Order]>(url, {
      headers: headers,
      params: body
    });
  }

  getInvoiceById(token, invoiceId): Observable<Order> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    this.currentProject = this.storageService.getPreferredProject();

    const body = {};

    if (this.currentProject !== null){
      body['project'] = this.currentProject.toString();
    }
    const url = environment.APIEndpoint + `client-api/invoices/${invoiceId}/`;
    return this.http.get<Order>(url, {
      headers: headers,
      params: body
    });
  }

  getInvoiceAndOrderById(token, orderId, invoiceId): Observable<any> {
    this.uiService.loadingStateChanged.next(true);
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token ${token}`);
    const body = {};
    const url = environment.APIEndpoint + `client-api/v2/invoices/${orderId}/invoice/${invoiceId}/`;
    return this.http.get<any>(url, {
      headers: headers
    });
  }

}
